[
  {
    "id": "start",
    "eyebrow": "Республика Алтай · июль 2026",
    "title": "Алтай на автодоме",
    "description": "Пять дней дороги — от спокойной Катуни до снежных вершин Северо-Чуйского хребта.",
    "routeProgress": 0,
    "coordinates": [85.849234, 51.967854],
    "layout": "hero",
    "photos": [],
    "camera": { "zoom": 8.1, "bearing": -12, "pitch": 30, "contentSide": "left" },
    "effects": ["clouds"],
    "audio": "wind",
    "scrollWeight": 1.25
  },
  {
    "id": "manzherok",
    "eyebrow": "День 1 · первые километры",
    "title": "Манжерок",
    "description": "Получив автодом в Майме, выходим к Катуни. Дорога быстро оставляет город позади и начинает петлять между лесистыми склонами.",
    "routeProgress": 0.032565,
    "coordinates": [85.767222, 51.828611],
    "layout": "text-only",
    "photos": [],
    "camera": { "zoom": 10.4, "bearing": 14, "pitch": 40, "contentSide": "right" },
    "effects": ["sun"],
    "audio": "road",
    "scrollWeight": 0.85
  },
  {
    "id": "chemal",
    "eyebrow": "День 2 · Чемальский тракт",
    "title": "Чемал",
    "description": "Здесь горная вода проходит через старую Чемальскую ГЭС, а скалы подходят совсем близко к берегу.",
    "routeProgress": 0.107917,
    "coordinates": [86.006389, 51.405833],
    "layout": "single",
    "photos": ["img_5015"],
    "camera": { "zoom": 12.1, "bearing": 20, "pitch": 47, "contentSide": "left" },
    "effects": ["water", "sun"],
    "audio": "river",
    "scrollWeight": 1.2
  },
  {
    "id": "patmos",
    "eyebrow": "Над Катунью",
    "title": "Остров Патмос",
    "description": "Узкий подвесной мост ведёт к маленькому скальному острову. Под ногами шумит Катунь, а тропа цепляется за отвесный берег.",
    "routeProgress": 0.109077,
    "coordinates": [86.0014, 51.3992],
    "layout": "stack",
    "photos": ["img_5020", "img_5023"],
    "camera": { "zoom": 13.2, "bearing": -22, "pitch": 52, "contentSide": "right" },
    "effects": ["mist", "water"],
    "audio": "river",
    "scrollWeight": 1.35
  },
  {
    "id": "kamlak",
    "eyebrow": "Ночёвка · центр Алтая",
    "title": "Камлак",
    "description": "Возвращаемся на Чуйский тракт и устраиваем дом прямо среди сосен. Внутри — тихий вечер перед самым длинным перегоном.",
    "routeProgress": 0.163238,
    "coordinates": [85.670833, 51.625556],
    "layout": "single",
    "photos": ["img_5031"],
    "camera": { "zoom": 10.7, "bearing": 8, "pitch": 38, "contentSide": "left" },
    "effects": ["clouds"],
    "audio": "forest",
    "scrollWeight": 1
  },
  {
    "id": "seminsky-pass",
    "eyebrow": "День 3 · 1717 метров",
    "title": "Семинский перевал",
    "description": "Чуйский тракт уходит вверх сквозь кедровый лес. На вершине воздух становится прохладнее, а дорога раскрывается далеко вперёд.",
    "routeProgress": 0.256557,
    "coordinates": [85.6, 51.045],
    "layout": "text-only",
    "photos": [],
    "camera": { "zoom": 10.4, "bearing": 32, "pitch": 54, "contentSide": "right" },
    "effects": ["mist", "clouds"],
    "audio": "wind",
    "scrollWeight": 1
  },
  {
    "id": "chike-taman",
    "eyebrow": "Дорога над ущельем",
    "title": "Перевал Чике-Таман",
    "description": "Серпантин вырезан в склоне, и каждый поворот открывает новый ярус гор. Здесь особенно чувствуется масштаб Чуйского тракта.",
    "routeProgress": 0.351936,
    "coordinates": [86.315, 50.635],
    "layout": "single",
    "photos": ["img_5074"],
    "camera": { "zoom": 11.2, "bearing": 46, "pitch": 57, "contentSide": "left" },
    "effects": ["sun", "clouds"],
    "audio": "wind",
    "scrollWeight": 1.15
  },
  {
    "id": "chuya-katun",
    "eyebrow": "Две реки",
    "title": "Слияние Чуи и Катуни",
    "description": "Молочная Чуя встречается с бирюзовой Катунью, и два цвета ещё долго идут рядом. Останавливаемся, чтобы увидеть это сверху и с воды.",
    "routeProgress": 0.398555,
    "coordinates": [86.625, 50.465],
    "layout": "sequence",
    "photos": ["img_4989", "img_5069", "img_7217"],
    "camera": { "zoom": 11.5, "bearing": -18, "pitch": 49, "contentSide": "right" },
    "effects": ["water", "sun"],
    "audio": "river",
    "scrollWeight": 1.45
  },
  {
    "id": "aktash",
    "eyebrow": "День 3 · ночёвка у реки",
    "title": "Акташ",
    "description": "К вечеру добираемся до Акташа и ставим автодом у воды. Вокруг — водопады, тёмные скалы и прохлада высокогорной ночи.",
    "routeProgress": 0.501691,
    "coordinates": [87.597053, 50.30634],
    "layout": "stack",
    "photos": ["img_5100", "img_5141", "img_5147"],
    "camera": { "zoom": 11.8, "bearing": 24, "pitch": 48, "contentSide": "left" },
    "effects": ["mist", "water"],
    "audio": "river",
    "scrollWeight": 1.4
  },
  {
    "id": "geyser-lake",
    "eyebrow": "День 4 · лесная тропа",
    "title": "Гейзерное озеро",
    "description": "За лесом вода оказывается почти нереально бирюзовой. Подводные источники рисуют на дне круги, которые медленно меняются на глазах.",
    "routeProgress": 0.50967,
    "coordinates": [87.667222, 50.289167],
    "layout": "sequence",
    "photos": ["img_5167", "img_5160", "img_7521"],
    "camera": { "zoom": 13.1, "bearing": -10, "pitch": 44, "contentSide": "right" },
    "effects": ["mist", "water", "sun"],
    "audio": "forest",
    "scrollWeight": 1.5
  },
  {
    "id": "kurai-steppe",
    "eyebrow": "Самая дальняя точка",
    "title": "Курайская степь",
    "description": "Степь распахивается до горизонта, а над ней поднимается снежный Северо-Чуйский хребет. Это самый просторный кадр всего путешествия.",
    "routeProgress": 0.54763,
    "coordinates": [87.932222, 50.223889],
    "layout": "stack",
    "photos": ["img_5174", "img_5175", "img_5183"],
    "camera": { "zoom": 9.9, "bearing": 8, "pitch": 42, "contentSide": "left" },
    "effects": ["clouds", "sun"],
    "audio": "wind",
    "scrollWeight": 1.55
  },
  {
    "id": "return-aktash",
    "eyebrow": "Поворот домой",
    "title": "Снова Акташ",
    "description": "Разворачиваем автодом на запад. Знакомые вершины теперь остаются позади, а впереди — длинный вечерний путь по Чуйскому тракту.",
    "routeProgress": 0.593826,
    "coordinates": [87.597053, 50.30634],
    "layout": "single",
    "photos": ["img_7342"],
    "camera": { "zoom": 10.5, "bearing": 198, "pitch": 38, "contentSide": "right" },
    "effects": ["sun"],
    "audio": "road",
    "scrollWeight": 0.95
  },
  {
    "id": "road-home",
    "eyebrow": "Обратный путь",
    "title": "Чуйский тракт",
    "description": "Перевалы проходят в обратном порядке, но дорога выглядит иначе. Свет становится мягче, и маршрут постепенно собирается в одну яркую линию.",
    "routeProgress": 0.743583,
    "coordinates": [86.315, 50.635],
    "layout": "text-only",
    "photos": [],
    "camera": { "zoom": 8.8, "bearing": 160, "pitch": 46, "contentSide": "left" },
    "effects": ["clouds"],
    "audio": "road",
    "scrollWeight": 0.9
  },
  {
    "id": "kamlak-return",
    "eyebrow": "Последняя ночь",
    "title": "Камлак",
    "description": "К вечеру возвращаемся туда, где начиналась большая часть пути. Осталось выспаться, привести дом в порядок и замкнуть маршрут.",
    "routeProgress": 0.929696,
    "coordinates": [85.670833, 51.625556],
    "layout": "single",
    "photos": ["img_5154"],
    "camera": { "zoom": 10.2, "bearing": -8, "pitch": 35, "contentSide": "right" },
    "effects": ["mist"],
    "audio": "forest",
    "scrollWeight": 0.95
  },
  {
    "id": "finish",
    "eyebrow": "День 5 · маршрут завершён",
    "title": "Снова дома",
    "description": "Возвращаем автодом в Майму. За пять дней карта превратилась из плана в историю — с шумом рек, горными дорогами и местами, куда хочется вернуться.",
    "routeProgress": 1,
    "coordinates": [85.849234, 51.967854],
    "layout": "sequence",
    "photos": ["img_5201", "img_5202", "img_5226"],
    "camera": { "zoom": 8.1, "bearing": -12, "pitch": 28, "contentSide": "left" },
    "effects": ["sun", "clouds"],
    "audio": "wind",
    "scrollWeight": 1.3
  }
]
